module.exports = __webpack_public_path__ + "static/img/wenchuang.a2f1097.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tout/wenchuang.jpg
// module id = giDR
// module chunks = 1